import React from 'react'
import { LoaderInner, LoaderWrapper } from './Loader.styles'

export const Loader = () => {
  return (
    <LoaderWrapper>
      <LoaderInner>
        <div className="lds-ring">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </LoaderInner>
    </LoaderWrapper>
  )
}
